export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Routing.vue?vue&type=template&id=2622cd97"


//////////////////
// WEBPACK FOOTER
// ./src/components/Routing.vue?vue&type=template&id=2622cd97
// module id = 1689
// module chunks = 31